<template>
  <div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li v-for="credito in creditos" class="nav-item" role="presentation">
        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
          <span>Crédito: {{ no_credito(credito.contractFolio) }}</span>
        </a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <template v-if="creditos.length > 0">
      <div v-for="credito in creditos" class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <ActiveCredit :credito="credito" />
      </div>
      </template>
      <template v-else>
        No hay créditos activos
      </template>
    </div>
  </div>
</template>

<script>
import ActiveCredit from '../components/ActiveCredit'

import api from '@/api/clientes'

export default {
  components: {
    ActiveCredit,
	}
  ,data: function() {
    return {
      creditos: []
      ,credito_no_disponible: false
    }
  }
  ,mounted: function() {
    this.obtener_creditos();
  }
  ,methods: {
    obtener_creditos: async function() {
      try {
        if (process.env.VUE_APP_ENV != 'production') {
          this.creditos = (await api.listar_creditos()).data;

          this.creditos = this.procesar_creditos(this.creditos);
        }else {
          if (!this.$store.state.creditos) {
            this.creditos = (await api.listar_creditos()).data;

            this.creditos = this.procesar_creditos(this.creditos);

            this.$store.commit('set',{creditos: this.creditos});
          }else {
            this.creditos = this.procesar_creditos(this.$store.state.creditos);
          }
        }
      }catch(e) {
        this.$log.info('err',e);
        this.$helper.axios_error(e);
      }
    }
    ,procesar_creditos: function(creditos) {
      for(let i=0; i<creditos.length; i++) {
        /**-------- AVATAR DESHABILITADO ------------**/
        /**if (creditos[i].avatar_estatus != 0) {
          this.$store.commit('set',{credito_avatar: creditos[i]});
          i = creditos.length;
          this.$router.push({name: 'pre-avatar'});
        }**/

        if (creditos[i].creditDueDate.indexOf('.') == -1) {
          creditos[i].creditDueDate = '<span style="color:red;font-weight:bold;">'+creditos[i].creditDueDate+'</span>';
        }
      }

      return creditos;
    }
    ,no_credito: function(no_credito) {
      if (no_credito)
        return no_credito.substr(11);
    }
  }
}
</script>